"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_transition_group_1 = require("react-transition-group");
const decorators_1 = require("../../../common/decorators");
// components
const Carousel_1 = __importDefault(require("../Interactive/Carousel/Carousel"));
const TilesContainer_1 = __importDefault(require("../Interactive/Tiles/TilesContainer"));
const ItemsList_1 = __importDefault(require("../Interactive/Tiles/ItemsList"));
const WeatherPage_1 = __importDefault(require("./DSLinearPages/WeatherPage"));
const ActivitiesList_1 = __importDefault(require("../Interactive/Tiles/ActivitiesList"));
const Header_1 = __importDefault(require("../Interactive/Header"));
const ItemDetailModal_1 = __importDefault(require("../Modal/ItemDetailModal"));
const SubpageControlsBar_1 = __importDefault(require("../Interactive/SubpageControlsBar"));
const services_1 = require("../../../common/services");
const useIdleTimeout_1 = __importDefault(require("../../hooks/useIdleTimeout"));
const DSInteractiveMainPage = ({ updateStore, enabledLocales, directories, offers, isCarouselPaused, currentLocale, urlParams, }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const match = (0, react_router_dom_1.useRouteMatch)();
    const streamDetails = Object.assign(Object.assign({}, urlParams), { locale: currentLocale, daysToFetch: 0 });
    if (enabledLocales.length < 1) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const settings = {
        stopSlideShow: false,
        stopAnimationsInSlide: false,
        changeSlideInterval: 100000000000000,
        fadeInContentTime: 100,
        speed: 1,
    };
    const isSubPage = location.pathname.includes('/overview/');
    const isWeatherPage = location.pathname.includes('/overview/weather');
    (0, react_1.useEffect)(() => {
        if (isSubPage) {
            updateStore('isCarouselPaused', true);
        }
        else {
            if (isCarouselPaused) {
                updateStore('isCarouselPaused', false);
            }
        }
    }, [isSubPage]);
    (0, react_1.useEffect)(() => {
        const fetchActivities = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const allActivities = yield services_1.apiService.getActivitiesFeed(streamDetails);
                const unfilteredActivities = allActivities.filter((activity) => activity.tags.indexOf('hide_on_ds') === -1);
                updateStore('unfilteredActivities', unfilteredActivities);
            }
            catch (error) {
                console.error('Error fetching activities:', error);
            }
        });
        fetchActivities();
    }, [currentLocale]);
    const closeWeatherPage = (0, react_1.useCallback)(() => {
        history.push({
            pathname: `${match.url}`,
            search: location.search,
        });
    }, [history, location.search, match.url]);
    (0, useIdleTimeout_1.default)(isWeatherPage, closeWeatherPage);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !isSubPage ? react_1.default.createElement(Header_1.default, null) : react_1.default.createElement(SubpageControlsBar_1.default, { renderAs: "header" }),
        react_1.default.createElement(Carousel_1.default, null),
        react_1.default.createElement(TilesContainer_1.default, null),
        react_1.default.createElement(ItemDetailModal_1.default, null),
        react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: `route-section ${isSubPage ? 'is-sub-page' : ''}`, component: "section" },
            react_1.default.createElement(react_transition_group_1.CSSTransition, { key: location.key, classNames: "fade-and-scale-animation", timeout: { enter: 500, exit: 350 } },
                react_1.default.createElement(react_router_dom_1.Switch, { location: location },
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${match.url}/directory`, render: () => react_1.default.createElement(ItemsList_1.default, { collection: directories }) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${match.url}/offers`, render: () => react_1.default.createElement(ItemsList_1.default, { collection: offers }) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${match.url}/activities`, component: ActivitiesList_1.default }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${match.url}/weather`, render: () => react_1.default.createElement(WeatherPage_1.default, { isDsInteractive: true, settings: settings }) })))),
        isSubPage && react_1.default.createElement(SubpageControlsBar_1.default, { renderAs: "footer" })));
};
const mapStoreToProps = store => ({
    enabledLocales: store.getValue('enabledLocales'),
    directories: store.getValue('directory'),
    offers: store.getValue('offers'),
    isCarouselPaused: store.getValue('isCarouselPaused'),
    currentLocale: store.getValue('currentLocale'),
    urlParams: store.getValue('urlParams'),
});
exports.default = (0, decorators_1.withStore)(mapStoreToProps)(DSInteractiveMainPage);
